import { useEffect } from "react";
import "../../assets/css/news_detail_modal.scss";

function NewsDetailModal({ news, onClose }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);

    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "unset";
    };
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="news-detail-modal-overlay" onClick={handleBackdropClick}>
      <div className="news-detail-modal">
        <button className="modal-close-btn" onClick={onClose}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="modal-content">
          <div className="modal-badge">
            <span>{news.badge}</span>
          </div>

          <div className="modal-date">{news.date}</div>

          <h2 className="modal-title">{news.title}</h2>

          {/* {news.image && (
            <div className="modal-image">
              <img src={news.image} alt={news.title} />
            </div>
          )} */}

          <div
            className="modal-description"
            dangerouslySetInnerHTML={{ __html: news.fullDesc || news.desc }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default NewsDetailModal;
